import appendQueryParams from "@/utils/appendQueryParams";
import { QueryFunctionContext } from "@tanstack/react-query";
import client from "../client";
import { ITagOverviewMap } from "@/modules/SiteVisiter/siteVisitor.interface";

export const getSiteVisiterList = async <T>(
  data: QueryFunctionContext
): Promise<T> => {
  return client.get(
    appendQueryParams("/site-visitors", data.meta?.queryParams ?? {})
  );
};
export const getDisplaySiteVisiterList = async (data: QueryFunctionContext) => {
  return client.get(
    appendQueryParams("/site-visitors/display", data.meta?.queryParams ?? {})
  );
};
/**
 * Vendor rollups for a set of pixel tags, keyed by identifier.
 *
 * POST rather than GET for two reasons: a page of identifiers overflows a query
 * string, and `client.ts` injects `advertiserId` into every GET, which this
 * endpoint deliberately does not accept — the identifier list is the scope.
 *
 * The server drops any identifier the requester may not read, so a missing key
 * means "no data for you" and "no data at all" alike. Both render the same.
 */
export function getTagsOverview(
  payload: {
    identifiers: string[];
    includeDomains?: boolean;
  }
): Promise<ITagOverviewMap> {
  // `as unknown as`, the same way `abmCbmReports.ts` does it and for the same
  // reason: the response interceptor returns `response.data`, so what actually
  // resolves is the body, while the axios types still describe an
  // `AxiosResponse`. Without the annotation the caller's `useQuery<...>` is an
  // assertion nobody checks, and a backend shape change would surface as
  // `undefined` at runtime rather than as a compile error.
  return client.post(
    "/site-visitors/overview",
    payload
  ) as unknown as Promise<ITagOverviewMap>;
}
export function createSiteVister(payload: any) {
  return client.post("/site-visitors", payload);
}
export function editSiteVister({ id, payload }: { id: any; payload: any }) {
  return client.put(`/site-visitors/${id}`, payload);
}

export function uploadLinkedinEngagemantFile({ payload }: { payload: any }) {
  return client.post(`/linkedinEngagement/upload-file`, payload);
}
